import React, {useState} from "react";
import {Checkbox, FormControlLabel} from "@mui/material";
import {produce} from "immer";
const ProjectDetailCheckbox = ({
                                 productItemId, 
                                 field, 
                                 draftQuoteDetail, 
                                 setDraftQuoteDetail, 
                                 disabled, 
                                 customFormSetter
}) => 
{
    const [checked, setChecked] = useState(() => {
        if (!!draftQuoteDetail.productItemId) {
            const val = draftQuoteDetail.quoteDetailFieldValues?.find(detail =>
                detail.productItemId === productItemId)?.fields
                .find(updatedField => updatedField.fieldId === field?.id).value;
            return val === "YES";
        }
        
        if (!!draftQuoteDetail.productGroupId) {
            const val = draftQuoteDetail.categoryItems.find(item => item.productItemId === productItemId)
                ?.fields?.find(x => x.fieldId === field?.id).value;
            
            return val === "YES";
        }
        
        return false;
    });
    
    const handleChange = e => {
        const newValue = e.target.checked;
        setChecked(newValue);
        if (customFormSetter) {
            customFormSetter(newValue);
        } else {
            setDraftQuoteDetail(prevState => produce(prevState, draft => {
                const fieldToUpdate = draft.quoteDetailFieldValues
                    .find(detail => detail.productItemId === productItemId)
                    ?.fields.find(fld => fld.fieldId === field.id);
                if (fieldToUpdate) {
                    fieldToUpdate.value = newValue ? "YES" : "NO";
                }
            }))
        }
    };
    
    return (
        <FormControlLabel
            disabled={disabled}
            control={<Checkbox name={field.name} checked={checked} onChange={handleChange} />}
            label={field.displayName}
        />
    );
};

export default ProjectDetailCheckbox;